import * as React from "react";
const SvgFiRrBurrito = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M21 4a3.015 3.015 0 0 0-4.136-2.776A4.03 4.03 0 0 0 12 .545a3.975 3.975 0 0 0-4.868.678C3.875-.024 1.618 4.078 4 6.467V18a6.006 6.006 0 0 0 6 6h4a6.006 6.006 0 0 0 6-6V6.467A3.68 3.68 0 0 0 21 4M6.4 3.086a1.9 1.9 0 0 0 2.168-.47 2.01 2.01 0 0 1 2.76-.094 1 1 0 0 0 1.337 0 2.01 2.01 0 0 1 2.76.1 1.9 1.9 0 0 0 2.166.471c1.282-.428 1.807 1.1 1.02 1.936a9.56 9.56 0 0 0-6.227 3.013c-.448-.33-.9-.627-1.354-.909.64-.948 2.51-1.342 1.8-2.671-1.17-1.365-2.656.8-3.6 1.684a10.9 10.9 0 0 0-3.84-1.121C4.6 4.2 5.116 2.664 6.4 3.086M14 22h-4a4 4 0 0 1-4-4V7.1c4.125.8 10.688 6.1 11.825 12.069A4.01 4.01 0 0 1 14 22m4-7.834A20.4 20.4 0 0 0 13.951 9.3a7.84 7.84 0 0 1 4.05-2.211zM12 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-2 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3-1a1 1 0 1 1 0 1.999A1 1 0 0 1 13 18"
    />
  </svg>
);
export default SvgFiRrBurrito;
